// extracted by mini-css-extract-plugin
export default {"root":"ynZ0M"};